import { QueryClient } from '@tanstack/react-query';
import { Params } from 'react-router-dom';
import {
  trialDetailLoader,
  trialPermissionsLoader,
} from '@app/pages/b2b/TrialRecruitment/TrialPage';

/** Prefetches the trial and the user's trial permissions, as the live trial page does. */
export const trialsRedesignLoader =
  (qC: QueryClient) =>
  async ({ params }: { params: Params }): Promise<null> => {
    const trial = await trialDetailLoader(qC, { params });
    await trialPermissionsLoader(qC, trial?.trialId ?? '');
    return null;
  };
